import React,{useContext} from "react";
import { useChat } from "../../context/provider/ChatProvider";
import { UserContext } from "../../context/provider/UserProvider";



const useChatActions = () => {
    const { socket } = useChat();
    const {stateUser} = useContext(UserContext)
    // const joinRoom = (roomID) => {
    //     console.log("ROOOMID ->",roomID)
    //     socket.emit('join-room', roomID);
    // }

    const joinRoom = (room) => {
        console.log("joinRoom ->",room.selectedRoom.id,stateUser.uid)
        socket.emit('join-room', {
            "roomId": room.selectedRoom.id,
            "nickname": stateUser.uid
        }, (response) => {
            if (response.success) {
                console.log(`Te uniste a la sala ${room.selectedRoom.id}`);
            } else {
                console.error(`Error al unirse a la sala: ${response.message}`);
            }
        });
    }


    const leaveRoom = (roomID) => {
        console.log("leave-room ->",roomID)
        socket.emit('leave-room', roomID);
    }


    const sendMessage = ( room, text, userName, messageType = "text", mediaFile = null, replyTo = undefined) => {
        if(! text && messageType === "text") {
            return;
        }
        console.log("send-message ->",room.id, text)
        
        const payload = {
            "room": room.id,
            "content": text,
            messageType,
            "media": mediaFile,
            "appointed": true
        }

        if (replyTo) {
            payload.replyTo = replyTo;
        }

        socket.emit('send-message', payload);

    }

    return {
        joinRoom,
        sendMessage,
        leaveRoom
    }
};

export default useChatActions;